import * as THREE from "three";
import { PlaneGeometry } from "three";
import BaseWebGL from "./base";
import GUI from 'lil-gui';
// import vertexShader from "./shaders/orb-org/vertex.glsl";
// import fragmentShader from "./shaders/orb-org/fragment.glsl";
import vertexShader from "./shaders/orb-org/vertex.glsl";
import fragmentShader from "./shaders/orb-org/fragment.glsl";

export default class OrbBgAnimation extends BaseWebGL {

  constructor(frameEl, params) {
    super(frameEl)
    this.reqId;
    this.mesh;
    this.props;

    this.tickTime = 0.01;
    // this.tickTime = 0.0;
    this.point1 = 1.0;
    this.point2 = 1.0;
    this.point3 = 1.0;
    this.blendval = -.35;
    this.size = this.isSmartPhone() ? 2.2 :2.5;
    this.initLight();

    this.params = params || {
      orb1Color: 0x00ff00,
      orb2Color: 0xff0000,
      orb3Color: 0x0000ff,
    };
  }

  initRenderer(frameEl) {
    this.renderer.setSize(frameEl.clientWidth, frameEl.clientHeight)
    this.renderer.setClearColor(0x1c1c1c);
    frameEl.appendChild(this.renderer.domElement)
  }
  initGui() {
    const gui = new GUI();
    const props = {
      tickTime: this.tickTime,
      point1: this.point1,
      point2: this.point2,
      point3: this.point3,
      blendval: this.blendval,
      size: this.size,
    }
    gui.add(props, 'tickTime', 0.0, 1.0, 0.01).onChange((value) => { this.tickTime = value; })
    gui.add(props, 'point1', 0.0, 2.0, 0.01).onChange((value) => { this.point1 = value; })
    gui.add(props, 'point2', 0.0, 1.0, 0.01).onChange((value) => { this.point2 = value; })
    gui.add(props, 'point3', 0.0, 1.0, 0.01).onChange((value) => { this.point3 = value; })
    gui.add(props, 'blendval', -5.0, 5.0, 0.01).onChange((value) => { this.blendval = value; })
    gui.add(props, 'size', -5.0, 5.0, 0.01).onChange((value) => { this.size = value; })
    // gui.add(props,'test')
    // gui.add(this.props, 'speed', -0.3, 1.5, 0.1);
  }
  async initObject() {
    const frame = this.frame
    const width = frame.clientWidth;
    const height = frame.clientHeight;
    const geometry = new PlaneGeometry(2, 2);
    const material = new THREE.ShaderMaterial({
      // wireframe: true,     
      uniforms: {
        color1: { value: this.hexToVec3(this.params.orb1Color) },
        color2: { value: this.hexToVec3(this.params.orb2Color) },
        color3: { value: this.hexToVec3(this.params.orb3Color) },
        resolution: { value: new THREE.Vector2(width, height) },
        time: { value: this.tickTime },
        point1: { value: this.point1 },
        point2: { value: this.point2 },
        point3: { value: this.point3 },
        blendval: { value: this.blendval },
        size: { value: this.size },
        orbsize: { value: this.isSmartPhone() ? .32: .38 },
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
    })
    this.ImageMesh = new THREE.Mesh(geometry, material);
    this.scene.add(this.ImageMesh)
    // this.initGui()
    // console.log(this.ImageMesh.geometry.attributes.position.array)
  }
  animation() {
    this.ImageMesh.material.uniforms.time.value += this.tickTime;
  }
  tick = () => {
    this.reqId = requestAnimationFrame(this.tick)
    this.animation()
    this.renderer.render(this.scene, this.camera);
  }
  initCamera(frameEl) {
    this.camera.position.set(0, 0, 1920);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
  }
  resize() {
    const frame = this.frame
    const onResize = () => {
      const width = frame.clientWidth;
      const height = frame.clientHeight;
      const aspect = width / height;
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(width, height);

      if (this.ImageMesh) {
        this.ImageMesh.material.uniforms.resolution.value = new THREE.Vector2(width * 2, height * 2)
      }
      this.camera.aspect = aspect;
      this.camera.updateProjectionMatrix();
    }
    onResize();
    window.addEventListener('resize', onResize);
  }
}

